<template>
  <div class="">
    <v-card class="pa-3 fund-description-box">
      <v-card class="fund-description-container" v-if="i18n.locale == 'en'">
        <h2 v-if="$vuetify.breakpoint.mdAndUp" class="h2 red--text">Important Notice</h2>
        <br v-if="$vuetify.breakpoint.mdAndUp" />
        <p class="black--text">
          <span class="font-weight-bold">
            1. If your deposit has not been credited within 10 minutes, please contact our 24/7 live customer support
            immediately and provide your Proof of Transaction (POT) so we can assist you in verifying the payment.
          </span>
          <br />
          <br />
          <span class="font-weight-bold">2. Use Only Official Deposit Channels</span>

          <br />
          All deposits must be made exclusively through the official channels listed on our website or app.
          Do not transfer funds to personal accounts or agents. Do not follow instructions from anyone claiming to
          represent our platform unless verified through official live chat.
          <br />
          <br />
          <span class="font-weight-bold">3. Beware of Scams and Fake Agents</span>

          <br />
          Fraudsters may pose as our staff or use fake websites to trick users into depositing money. Always
          double-check the deposit account and payment instructions on our official page before making any transfer.
          <br />
          <br />

          <span class="font-weight-bold">4. Contact Us for Verification</span>

          <br />
          If you are unsure whether a payment channel is official, please contact our 24/7 live chat support for
          confirmation before proceeding. Our support team is always available to verify and assist.
          Your safety is our top priority. Depositing through unofficial channels is at your own risk, and we will
          not be responsible for any loss resulting from such actions. Thank you for your understanding and cooperation
          in keeping your account secure.
          <br />
        </p>
      </v-card>
      <v-card class="fund-description-container" v-else>
        <h2 v-if="$vuetify.breakpoint.mdAndUp" class="h2 red--text">গুরুত্বপূর্ণ বিজ্ঞপ্তি</h2>
        <br v-if="$vuetify.breakpoint.mdAndUp" />
        <p class="black--text">
          <span class="font-weight-bold">১.যদি আপনার ডিপোজিট ১০ মিনিটের মধ্যে আপনার অ্যাকাউন্টে ক্রেডিট</span>
          <br />
          না হয়, তাহলে দয়া করে অবিলম্বে আমাদের ২৪/৭ লাইভ কাস্টমার সাপোর্টের সাথে যোগাযোগ করুন এবং যাচাইয়ের জন্য আপনার প্রমাণ হিসেবে ট্রানজ্যাকশন (POT) প্রদান করুন।
          <br />
          <br />

          <span class="font-weight-bold">২. শুধুমাত্র অফিসিয়াল জমা চ্যানেল ব্যবহার করুন</span>
          <br />
          সব ধরনের জমা অবশ্যই আমাদের অফিসিয়াল ওয়েবসাইট বা অ্যাপে তালিকাভুক্ত অফিসিয়াল চ্যানেলের মাধ্যমে করতে হবে। ব্যক্তিগত অ্যাকাউন্ট বা এজেন্টদের কাছে অর্থ পাঠাবেন না। কেউ আমাদের প্ল্যাটফর্মের প্রতিনিধি বলে দাবি করলে, অফিসিয়াল লাইভ চ্যাটের মাধ্যমে যাচাই না করা পর্যন্ত তাদের নির্দেশ অনুসরণ করবেন না।
          <br />
          <br />

          <span class="font-weight-bold">৩. প্রতারক এবং ভুয়া এজেন্টদের থেকে সাবধান থাকুন</span>
          <br />
          প্রতারকরা আমাদের স্টাফ সেজে বা ভুয়া ওয়েবসাইট ব্যবহার করে ব্যবহারকারীদের কাছ থেকে টাকা নেবার চেষ্টা করতে পারে। যেকোনো অর্থ পাঠানোর আগে আমাদের অফিসিয়াল পেজে প্রদত্ত জমার অ্যাকাউন্ট ও নির্দেশাবলী ভালোভাবে যাচাই করুন।
          <br />
          <br />

          <span class="font-weight-bold">৪. যাচাইয়ের জন্য আমাদের সাথে যোগাযোগ করুন</span>
          <br />
          যদি আপনি নিশ্চিত না হন যে কোনো পেমেন্ট চ্যানেল অফিসিয়াল কিনা, তবে অর্থ পাঠানোর আগে দয়া করে আমাদের ২৪/৭ লাইভ চ্যাট সাপোর্টে যোগাযোগ করুন। আমাদের সাপোর্ট টিম সর্বদা যাচাই এবং সহায়তার জন্য প্রস্তুত। আপনার নিরাপত্তাই আমাদের প্রথম অগ্রাধিকার। অননুমোদিত চ্যানেলের মাধ্যমে অর্থ জমা দিলে তা সম্পূর্ণভাবে আপনার নিজের ঝুঁকিতে, এবং এই ধরনের ক্ষতির জন্য আমরা কোনো দায় নেব না। আপনার বোঝাপড়া এবং সহযোগিতার জন্য ধন্যবাদ — আপনার অ্যাকাউন্ট নিরাপদ রাখতে আমাদের সাথে থাকুন।
          <br />
        </p>
      </v-card>
    </v-card>
  </div>
</template>

<script>
import { formValidator } from '@/util'
import i18n from '@/plugins/i18n'

export default {
  name: 'fundSideDescription',
  components: {},
  data: () => ({
    validator: formValidator,
    i18n
  })
}
</script>

<style lang="scss">
.fund-description-box {
  border-radius: 8px;
  background-color: var(--v-background-lighten1) !important;
}

.fund-description-container {
  background: transparent !important;
  font-size: 12px;
  border: none !important;
  box-shadow: none !important;
}
</style>
